<application-shell
    [linkQueryParams]="null | workspaceQueryParams"
    [groups]="filteredGroups()" [crumbs]="crumbs" [collapsed]="collapsed" [sidebarOpen]="sidebarOpen"
    [menuFilter]="menuFilter()" [collapsedGroups]="collapsedGroups()" [favoriteLinks]="fav.routes()" [exactRoutes]="exactRoutes()"
    [logoUrl]="logoUrl" [navLogoUrl]="navLogoUrl" [brandTitle]="workspaceName()"
    [accountName]="accountName()" [workspaceName]="workspaceName()" [workspaceMeta]="workspaceMeta()"
    [selectableWorkspace]="canSelectWorkspaceTenant()" [status]="backendAvailability.overallState()"
    (sidebarToggle)="toggleSidebar()" (sidebarClose)="closeSidebar()" (brandClick)="onBrandClick()"
    (groupToggle)="toggleGroup($event)" (menuFilterChange)="onMenuFilter($event)"
    (favoriteToggle)="toggleShellFavorite($event)" (viewportChanged)="onResize()">
    <tenant-workspace-select shell-workspace *ngIf="canSelectWorkspaceTenant()" [compact]="true" [showAll]="true" />
    <div shell-actions><languages /><notification-inbox /><user /></div>
    <router-outlet />
</application-shell>
<!-- Persistent import state must survive route changes. -->
<bulk-import-host /><bulk-import-dock />
